import React from 'react';
import { createGlobalStyle } from 'styled-components';
import tw, { theme, GlobalStyles as BaseStyles } from 'twin.macro';

const CustomStyles = createGlobalStyle`
  body {
    ${tw`antialiased`}
  }
  pre, code, kbd, samp {
    ${tw`font-mono`}
  }
  button:focus,
  a:focus {
    /* Provide a fallback style for browsers
      that don't support :focus-visible */
      ${tw`outline-none ring ring-blue-lighten-20`}
  }

  button:focus:not(:focus-visible),
  a:focus:not(:focus-visible) {
    /* Remove the focus indicator on mouse-focus for browsers
      that do support :focus-visible */
    ${tw`outline-none ring-0`}
  }

  button:focus-visible,
  button:focus:focus-visible,
  a:focus-visible,
  a:focus:focus-visible {
    /* Draw a very noticeable focus style for
      keyboard-focus on browsers that do support
      :focus-visible */
    ${tw`outline-none ring ring-blue-lighten-20`}
  }
`;

const GlobalStyles = () => (
  <>
    <BaseStyles />
    <CustomStyles />
  </>
);

export default GlobalStyles;
